import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

interface Props {
  message?: string;
  correlationId?: string;
  onRetry: () => void;
}

/** Error display with retry button and optional correlationId reference. */
export default function RetryableError({ message, correlationId, onRetry }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        px: 4,
        gap: 1.5,
      }}
    >
      <Typography variant="h6" color="error">
        {message || 'Failed to load data'}
      </Typography>
      {correlationId && (
        <Typography variant="caption" color="text.secondary">
          Reference: {correlationId}
        </Typography>
      )}
      <Button variant="outlined" onClick={onRetry} sx={{ mt: 1 }}>
        Retry
      </Button>
    </Box>
  );
}
